import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { InputComponent } from '@shared/input/input.component';
import { GetStartedService } from '@shared/get-started/get-started.service';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'companyid-get-started',
    imports: [InputComponent, ReactiveFormsModule],
    templateUrl: './get-started.component.html',
    styleUrl: './get-started.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetStartedComponent {
    private readonly getStartedService = inject(GetStartedService);

    public readonly emailFormControl = this.getStartedService.emailFormControl;

    public sendEmail(): void {
        this.getStartedService.sendEmail();
    }
}
